

    let fadeInTarget = document.querySelectorAll('.fadein-animation');
    window.addEventListener('scroll', () => {
    for (let i = 0; i < fadeInTarget.length; i++){
    const rect = fadeInTarget[i].getBoundingClientRect().top;
    const scroll = window.pageYOffset || document.documentElement.scrollTop;
    const offset = rect + scroll;
    const windowHeight = window.innerHeight;
    if (scroll > offset - windowHeight + 150) {
    fadeInTarget[i].classList.add('scroll-in');
}
}
});

    document.querySelectorAll(".t_big, .t_name").forEach((element) => {
        element.addEventListener("click", function () {
            this.classList.toggle("active");
        });
    });